// ============================================================================
// ENGLISH TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'en',
    languageName: 'English',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Chronicles\nof Love",
    subtitle: "Interactive Scripture Discovery",
    tagline: "Walking toward divine light",
    menu: "Menu",
    retry: "Retry"
  },
  
  buttons: {
    play: "PLAY",
    back: "Back",
    continue: "Continue",
    restart: "Restart",
    close: "Close",
    nextLevel: "Next Level",
    selectLevel: "Level Selection",
    retry: "Try Again",
    mainMenu: "Main Menu",
    start: "Start",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    load: "Load",
    yesRestart: "Yes, restart",
    noContinue: "No, continue",
    tryAgain: "Try Again",
    backToMenu: "Back to menu"
  },
  
  labels: {
    score: "Score",
    stars: "Stars",
    wisdom: "Wisdom",
    revelation: "Revelation",
    lives: "Lives",
    combo: "Combo",
    level: "LEVEL",
    easy: "EASY",
    medium: "MEDIUM",
    hard: "HARD",
    correct: "Correct!",
    gameOver: "Trial Failed",
    victory: "Victory!",
    completed: "Completed",
    rank: "Spiritual Rank",
    points: "Wisdom Points",
    unlockedLevels: "level(s) unlocked",
    questionOfKnowledge: "Question of Knowledge",
    hintOfWisdom: "Hint of Wisdom",
    knowledgeMastered: "Knowledge Mastered!",
    knowledgeAcquired: "Knowledge acquired!",
    testFailed: "Trial Failed",
    wisdomBonus: "Bonus",
    xpGained: "XP",
    newRank: "New rank",
    nextGrade: "Next grade",
    maxLevelReached: "Maximum level reached!",
    wrongAnswer: "Wrong answer!"
  },
  
  menu: {
    playButton: "PLAY",
    info: "Info",
    treasures: "Treasures",
    john: "John",
    reset: "Reset",
    restart: "🔄 Restart adventure?",
    confirmReset: "Are you sure you want to erase all your progress?",
    youWillLose: "You will lose:",
    wisdomPoints: "Wisdom Points",
    starsCollected: "stars collected",
    levelsUnlocked: "level(s) unlocked",
    spiritualRank: "Spiritual Rank",
    newAdventure: "🌟 New Adventure",
    readyToStart: "Ready to start?",
    startJourney: "Begin your journey into Scripture knowledge!",
    audioControls: "Audio controls",
    mute: "Mute sound",
    unmute: "Unmute sound",
    close: "Close",
    language: "Language",
    restartGame: "Restart game"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Interactive biblical adventure",
    anonymousMode: "Play Anonymous",
    anonymousDesc: "Choose a username",
    emailMode: "Email Login",
    emailDesc: "Multi-device save",
    pseudo: "Username",
    pseudoPlaceholder: "Your username...",
    email: "Email Address",
    emailPlaceholder: "your@email.com",
    startPlaying: "Start playing",
    sendLink: "Send link",
    sending: "Sending...",
    connecting: "Connecting...",
    back: "Back",
    localSave: "Your progress will be saved locally",
    cloudSync: "No password required • Cloud sync",
    magicLink: "Receive a magic link by email",
    checkEmail: "📧 Check your email! A login link has been sent to you.",
    checkSpam: "Check your spam/junk folder too",
    waitingConnection: "Waiting for connection...",
    errorSend: "Error sending link",
    rateLimited: "⏳ Please wait 15 seconds before resending an email",
    importSession: "🔄 Import session from production",
    errorConnection: "Connection error",
    enterPseudo: "Please enter a username",
    enterEmail: "Please enter a valid email",
    // Tooltips
    never: "Never",
    save: "Save game",
    lastSave: "last",
    refresh: "Reload progress",
    logout: "Log out",
    connectToCloud: "Connect to save online",
    editPseudo: "Edit username",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    passwordMode: "Simple Login",
    passwordDesc: "Email + password",
    password: "Password",
    passwordPlaceholder: "Minimum 6 characters",
    passwordMinLength: "Minimum 6 characters",
    playWithoutAccount: "Play without account",
    forgotPassword: "Forgot password?",
    resetPasswordTitle: "Reset Password",
    resetPasswordSubtitle: "Enter your email to receive a reset link",
    sendResetLink: "Send Reset Link",
    resetEmailSent: "📧 Reset email sent! Check your inbox.",
    errorReset: "Error sending reset email",
    backToSignin: "Back to Sign In",
    newPassword: "New Password",
    enterNewPassword: "Choose a new secure password",
    confirmPassword: "Confirm Password",
    updatePassword: "Update Password",
    passwordsDontMatch: "Passwords don't match",
    passwordUpdateSuccess: "✅ Password updated successfully!",
    errorUpdatePassword: "Error updating password",
    resetLinkExpired: "Reset link expired or invalid",
    forgotPassword: "Forgot password?",
    signup: "Sign Up",
    signin: "Sign In",
    createAccount: "Create Account",
    signupInfo: "Fill in the form below",
    passwordInfo: "Quick access with password",
    signupButton: "Create My Account",
    signinButton: "Sign In",
    passwordTooShort: "Password must be at least 6 characters",
    emailAlreadyExists: "This email is already in use",
    emailExistsHint: "✉️ This email is already registered. Try to sign in! (Maybe created from another game?)",
    switchToSignin: "🔑 Switch to Sign In mode with your existing email",
    invalidCredentials: "Invalid email or password",
    signupSuccess: "📧 Account created! Check your email to confirm your registration.",
    emailConfirmationRequired: "Check your email",
    checkSpamFolder: "Check spam too",
    connectionSuccess: "✅ Successfully logged in!",
    errorSignup: "Error during sign up"},
  
  install: {
    title: "Install the app",
    subtitle: "Quick access and offline",
    feature1: "Instant launch from your home screen",
    feature2: "Works offline after installation",
    feature3: "Native app experience",
    feature4: "No store download required",
    install: "Install",
    dismiss: "Later",
    info: "You can uninstall the app anytime"
  },
  
  ranks: {
    seeker: "Seeker",
    believer: "The Awakened",
    disciple: "Disciple",
    servant: "Servant",
    witness: "Witness",
    guardian: "Guardian",
    wise: "Wise One",
    prophet: "Prophet",
    apostle: "Apostle",
    seekerDesc: "Beginning of the spiritual journey",
    believerDesc: "Spiritual consciousness awakened",
    discipleDesc: "Learning the teachings",
    servantDesc: "Service and devotion",
    witnessDesc: "Sharing the faith",
    guardianDesc: "Protection of the truth",
    wiseDesc: "Wisdom and knowledge",
    prophetDesc: "Spiritual vision",
    apostleDesc: "Spiritual master"
  },

  spiritualJourney: {
    beginning: "Beginning of spiritual journey",
    progress: "Spiritual progress",
    grade: "Grade",
    xp: "XP",
    level: "Level",
    nextGrade: "Next grade",
    still: "Still",
    maxLevelReached: "Maximum Level Reached!",
    masteredAllTeachings: "You have mastered all teachings",
    progression: "Progress"
  },
  
  treasures: {
    title: "📖 Bible Treasures",
    verse: "Verse of the day",
    fact: "Did you know?",
    treasure: "🎁 Hidden treasure",
    question: "Fun question",
    newTreasure: "New treasure",
    context: "Context",
    strongReference: "Biblical reference for in-depth study",
    johnGospelDescription: "The Gospel of John reveals Jesus' divinity through 21 inspiring chapters.",
    availableInLanguages: "Available in 14 languages",
    johnGospelTitle: "Gospel of John",
    johnGospelStats: "21 chapters • 878 verses • 14 languages",
    bibleReaderStrong: "Bible Reader + Strong",
    bibleReaderStrongDesc: "Complete reading with Strong's dictionary",
    johnTreasures: "John's Treasures",
    johnTreasuresDesc: "Biblical treasures and interesting facts",
    johnBibleReader: "John Bible Reader + Strong",
    emmanuelMemo: "Emmanuel's Memo",
    emmanuelMessage: "You have reached the mountain top, and knowledge is acquired. But unwavering faith requires life experience, mercy, and true love of Jesus. Life's various trials will test your path, the true way we choose, our heart. We remain imperfect, our desires are many, and love of gain or personal comfort too often becomes our selfish priority. Ask God for wisdom, His love, His strength, and humbly acknowledge your weaknesses, for we can hide nothing from Him... Nothing. No need to browse in private mode, use VPN, or even clear history. Fast like Daniel: deprive yourself for a moment of what you love most, in calm and wisdom. This will allow you to better hear God, to have a heart disposition ready for profound — and often painful — transformations. Then dreams and visions will become clearer, as with Joseph. But guard against pride: do not yield to 'I'm always right' or 'I know better.' For God's revelation is an extraordinary grace. Don't become a teacher of the Law, capable of crucifying Jesus again today, He who simply asks to love your neighbor... and grant them the same freedom you yourself receive. Having faith means entering into a relationship and a free journey of the heart. It will make you powerful heroes, capable of the impossible. For the experience of the supernatural, God's presence, His confirmation or blessing will make you truly unshakeable.",
    clarification: "Important clarification",
    bibleOffline: "Read Bible Offline",
    bibleStudy: "Bible study",
    version: "Version",
    openReader: "Open reader",
    features: "Features"
  },
  
  messages: {
    chooseCard: "🃏 Choose your power card",
    cardHelp: "It will accompany you for the 3 questions of this level",
    chooseAnswer: "📖 Choose your answer:",
    wrongAnswer: "❌ Wrong answer! You have {lives} life/lives left. Try again!",
    levelCompleted: "Level {level} Completed",
    questionsProgress: "Question {current} of {total}",
    starsCollected: "Stars collected: {current}/{total}",
    pointsEarned: "+{points} Wisdom Points",
    secondChance: "🔥 Your COURAGE card gives you a second chance! Try again with wisdom.",
    bonusApplied: "🃏 {card} Bonus: +{percent}% ({base} → {final})",
    defeatedQuote: "I can do all things in Him who strengthens me",
    perfect: "🃏 Perfect",
    good: "✅ Good",
    start: "✅ Start",
    secretLevel: "🔓 SECRET LEVEL UNLOCKED!",
    secretChapter: "🎁 Secret Chapter",
    returnToLevels: "Return",
    next: "Next",
    retry: "Retry",
    menu: "Menu",
    chapter: "Chapter",
    chapterStars: "Chapter stars",
    totalGlobal: "Global total",
    backToMenu: "Back to Menu"
  },
  
  chapters: {
    "1": "Genesis",
    "2": "Exodus",
    "3": "Jesus Christ",
    "4": "Crucifixion/Resurrection",
    "5": "Early Church",
    "6": "Paul's Missions",
    "7": "Letters/Revelation",
    "8": "Bonus Level"
  },
  
  cards: {
    faith: "FAITH",
    courage: "COURAGE",
    wisdom: "WISDOM",
    faithKnowledge: "+50% points",
    courageKnowledge: "Second chance",
    wisdomKnowledge: "Hint + bonus",
    faithDesc: "Maximum wisdom points obtained",
    courageDesc: "Normal points but second chance",
    wisdomDesc: "Hint revealed and +25% points",
    chooseCard: "🃏 Choose a knowledge gift",
    cardEffects: "🃏 Knowledge gift effects:",
    faithEffect: "+50% wisdom points - Maximum reward",
    courageEffect: "Normal points but second chance on error",
    wisdomEffect: "+25% points + hint revealed for each question",
    chooseWisely: "Choose wisely, as your choice will accompany you throughout the level"
  },
  
  challenge: {
    loading: "Loading level...",
    peace: "🕊️ May peace rest in your house",
    questionsAwaiting: "📚 3 knowledge questions await you",
    starsQuote: "Each star is a step toward divine light"
  },
  
  info: {
    title: "Unity Quest Chronicles of Peace",
    subtitle: "Interactive Scripture Discovery",
    yourStats: "Your Statistics",
    score: "Score",
    wisdom: "Wisdom",
    revelation: "Revelation",
    createdWith: "Created with ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Developer passionate about spirituality",
    artistModule: "Emmanuel Artist",
    artistPortfolio: "Artistic portfolio and digital creations",
    features: "Features",
    multipleChapters: "91 levels across 8 biblical chapters",
    powerCards: "3 unique power cards (Faith, Courage, Wisdom)",
    progressionSystem: "Progression system with spiritual ranks",
    bibleTreasures: "Bible treasures and interesting facts",
    howToPlay: "How to Play",
    selectLevel: "Select an unlocked level",
    choosePowerCard: "Choose your power card",
    answerQuestions: "Answer the 3 knowledge questions",
    earnStars: "Earn stars based on remaining lives",
    tips: "Tips",
    readCarefully: "Read each question carefully",
    useWisdomCard: "Use the Wisdom card for hints",
    courageGivesSecondChance: "The Courage card gives you a second chance",
    faithMaximizes: "The Faith card maximizes your points",
    johnGospelTitle: "Gospel of John",
    johnGospelStats: "21 chapters • 878 verses • 14 languages",
    bibleReaderStrong: "Bible Reader + Strong",
    bibleReaderStrongDesc: "Complete reading with Strong's dictionary",
    johnTreasures: "John's Treasures",
    johnTreasuresDesc: "Biblical treasures and interesting facts",
    quickAccessChapters: "Quick access to famous chapters:",
    johnChapter1: "Prologue",
    johnChapter3: "Born Again",
    johnChapter14: "I Am the Way",
    johnChapter20: "Resurrection",
    version: "Version",
    madeWithLove: "Made with love for God's glory",
    backToMenu: "Back to Menu"
  },
  
  bible: {
    readerTitle: "📖 Bible Reader",
    johnReaderTitle: "Bible Reader - Gospel of John",
    john: "John",
    loading: "Loading Scriptures...",
    loadingChapter: "Chapter {chapter} of the Gospel of John. Full data is loading...",
    exploreWhileLoading: "Meanwhile, you can explore other chapters or use the search function.",
    menu: "Menu",
    tabBible: "Bible",
    tabUnity: "Unity",
    strong: "Strong",
    strongReferences: "Strong References",
    verses: "verses",
    previous: "Previous",
    next: "Next",
    strongDefinition: "Strong Reference",
    word: "Original word",
    transliteration: "Transliteration",
    close: "Close",
    share: "Share",
    shareVerse: "Share this verse",
    shareSelection: "Share selection",
    pronunciation: "Pronunciation",
    meaning: "Meaning",
    definition: "Complete definition",
    usage: "Biblical usage",
    etymology: "Etymology",
    search: "Search...",
    definitionNotFound: "Definition not found",
    definitionLoading: "Definition to load...",
    imageFeatureComing: "🖼️ Image feature coming!",
    copyError: "Copy error:",
    error: "❌ Error",
    errorLoading: "Loading error",
    retry: "Retry",
    readerInDevelopment: "John Bible Reader in development...",
    verseCopied: "Verse copied to clipboard!",
    moreReferences: "and {{count}} other references",
    copyright: "📖 Public Domain • Strong",
    markAsRead: "Passage read",
    alreadyRead: "Already read",
    readingBonus: "Reading bonus",
    results: "results",
    result: "result",
    copy: "Copy",
    image: "Image"
  },
  
  bibleResources: {
    inAppReader: {
      name: "Read in App",
      description: "Integrated Bible reader with Strong",
      features: {
        offline: "Offline",
        strong: "Strong Numbers",
        navigation: "Navigation"
      }
    }
  },
  
  mountain: {
    spiritualAscension: "Spiritual Ascension",
    levelProgress: "Level {{level}} • {{stars}} stars obtained",
    combo: "Combo",
    perfectMessage: '"For my thoughts are not your thoughts" - The lamb climbs toward perfect wisdom',
    goodMessage: '"Seek and you shall find" - The ascent continues toward truth',
    startMessage: '"Faith, even small as a mustard seed" - First step toward light',
    skipAnimation: "Skip animation",
    chapter: "Chapter",
    chapterProgress: "Chapter {{current}}/{{total}}",
    secret: "Secret",
    waypoints: {
      start: "Start",
      firstSlope: "First slope",
      lastSlope: "Last slope"
    },
    status: {
      defeat: "Defeat",
      inProgress: "In progress"
    }
  },
  
  quotes: {
    wisdom: "True knowledge leads to eternal wisdom",
    faith: "I can do all things through Christ who strengthens me",
    hope: "The Lord is my shepherd, I shall not want",
    love: "For God so loved the world...",
    perseverance: "Faith requires perseverance",
    defeat: "Failure invites growth in knowledge"
  },

  philosophy: {
    title: "Philosophical Dimension",
    loveOntology: "Love as ontological principle",
    loveDescription: "Jesus transforms love into a metaphysical foundation: loving God and others becomes the very structure of authentic being. Love transcends morality to become a mode of existence.",
    newCommandment: "The New Commandment",
    jesusEmphasizes: "When Jesus gives a new commandment, he emphasizes the verb to love",
    loveGod: "Love God with all your heart",
    loveNeighbor: "Love your neighbor as yourself",
    lovePriority: "Love becomes a priority"
  },

  unity: unityTranslations,

  footer: {
    version: "Version 1.0 • 2024",
    dedication: "Developed for God's glory"
  },

  endCredits: {
    lines: [
      { text: "You have reached the mountain top", delay: 2000 },
      { text: "You have learned many things", delay: 2000 },
      { text: "Your faith grows every day", delay: 2000 },
      { text: "You experience beautiful things with God", delay: 2000 },
      { text: "Difficulties help you grow", delay: 2000 },
      { text: "They show what is important", delay: 2000 },
      { text: "Be humble like a little child", delay: 2000 },
      { text: "God loves your simple heart", delay: 2000 },
      { text: "In silence you hear God", delay: 2000 },
      { text: "Fasting frees your spirit", delay: 2000 },
      { text: "Pray and God will guide you", delay: 2000 },
      { text: "Pride hides the truth", delay: 2000 },
      { text: "God's grace is magnificent", delay: 2000 },
      { text: "It comes from God's heart", delay: 2000 },
      { text: "True faith sets you free", delay: 2000 },
      { text: "It unites you with God forever", delay: 2000 },
      { text: "Love can change everything", delay: 2000 },
      { text: "It can work miracles", delay: 2000 },
      { text: "Repeat with me", delay: 2000 },
      { text: "Jesus, I give you my heart", delay: 3000 },
      { text: "You are my king, my savior", delay: 3000 },
      { text: "Come transform my life", delay: 3000 },
      { text: "The journey continues now", delay: 2000 },
      { text: "Share this beautiful light", delay: 2000 },
      { text: "Toward life that never ends", delay: 2000 },
      { text: "Keep love in your heart", delay: 3000 },
      { text: "Like a precious treasure", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "CONGRATULATIONS!",
      proud: "WE ARE PROUD OF YOU",
      courage: "VALIANT COURAGE",
      peace: "PEACEBEARER",
      child: "CHILD OF GOD",
      blessing: "MAY GOD BLESS YOU",
      continue: "Continue"
    }
  },

  validation: {
    pseudoTooShort: "Username must contain at least 2 characters",
    enterPseudo: "Please enter a username"
  },

  pseudoSetup: {
    title: "Choose your player username",
    profileConfig: "Profile Configuration",
    connectedWith: "Connected with",
    playerPseudo: "Player Username",
    pseudoPlaceholder: "Your username...",
    pseudoRequirements: "2-20 characters • Displayed in rankings",
    suggestions: "Suggestions",
    confirm: "Confirm Username",
    errorConfig: "Configuration error"
  },

  navigation: {
    back: "Back"
  },

  console: {
    starsUnlocked: "stars reached! Chapter unlock",
    defeatAnimation: "Defeat... J.C. descends"
  },

  errors: {
    progressionError: "Progression error",
    invalidProgressionData: "Invalid progression data:"
  },

  levels: {
    chaptersAndBonus: "8 chapters + bonus level",
    bonusUnlocked: "🎁 BONUS LEVEL UNLOCKED! You have reached spiritual perfection!",
    starsToDiscover: "273 {stars} to discover",
    starsPerLevel: "3 {stars} per level"
  },

  architecture: {
    title: "⚙️ Technical architecture",
    react: {
      name: "React",
      description: "Modern interface"
    },
    modules: {
      name: "Modules",
      description: "Dynamic loading"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Local save"
    },
    tailwind: {
      name: "Tailwind",
      description: "Responsive design"
    }
  },

  gameManager: {
    title: "Game save",
    saveLocal: "Local save",
    saveCloud: "Cloud synchronized",
    saveWaiting: "Waiting for connection",
    lastSave: "Last save:",
    never: "Never",
    saving: "Saving...",
    save: "Save",
    loadProgress: "Load",
    loading: "Loading...",
    autoSaveEnabled: "💾 Auto-save enabled",
    saveError: "❌ Save error",
    gameSaved: "✅ Game saved!",
    gameLoaded: "✅ Game loaded!"
  }
};

export default uiTranslations;
